export default __webpack_public_path__ + "static/media/bd-logo.b0b04eac.png";